import Article from 'ui/Element/List/Item/Cell/Article/Image'
import ServiceItem from 'ui/Element/List/Item/Cell/ServiceItem/Image'
import Request from 'ui/Element/List/Item/Cell/Request/Icon'
import Organisation from 'ui/Element/List/Item/Cell/Organisation/Icon'
import Person from 'ui/Element/List/Item/Cell/Person/Image'
import Equipment from 'ui/Element/List/Item/Cell/Equipment/Image'
import Documentation from 'ui/Element/List/Item/Cell/Documentation/Icon'

/**
 * Displays the appropriate list item based on the incoming `type`.
 *
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardIcon = (props) => {
  const {
    meta: { type: metaType = null } = {},
    docType = null,
  } = props || {}

  const type = metaType || docType

  return (
    <>
      {type === 'article' && (<Article {...props} />)}
      {type === 'equipment' && (<Equipment {...props} />)}
      {type === 'docChunk' && (<Documentation {...props} />)}
      {type === 'documentation' && (<Documentation {...props} />)}

      {type === 'serviceitem' && (<ServiceItem {...props} />)}
      {type === 'request' && (<Request {...props} />)}
      {type === 'organisation' && (<Organisation {...props} />)}
      {type === 'person' && (<Person {...props} />)}
    </>
  )
}

export default ListItemCellDashboardIcon
